import React from 'react';
import strings from "../Globalization/index";
import TrackCycleTable from '../AppGrid/TrackCycleTable';
import CommonBreadCurmb from '../components/common/CommonBreadCrumb';

const TrakCyclGrid = TrackCycleTable.createGridBase();

const TrackCycleFile = () => { 
	return (<CommonBreadCurmb
		actions={{ action: 'goback', route: '/cyclelist' }}
		docTitle={strings.cycleHistory}
		breadcrumbs={[{ text: strings.cycleHistory }]}
		Component={TrakCyclGrid}
	/>)
}

export default TrackCycleFile;